import axios from '@/util/requestUtil'
// const commonUrl = 'https://route-service-develop.eddid.com.cn:1443/open/account'
class Trade {
  // 用户信息、交易帐号信息
  getUserBalance(params) {
    return axios.get(`/trade/transaction/balance`, { params: params })
  }
  getOthersAccount(params) {
    return axios.get(`/trade/other-trade-accounts`, { params: params })
  }
  // 其他交易账号申请记录
  getTradeAccountRecord(params) {
    return axios.get(`/trade/trade-account/application/records`, {
      params: params
    })
  }
  // 实时行情申请记录
  getQuoteServiceRecord(params) {
    return axios.get('/trade/quote-service/application/records', {
      params: params
    })
  }
  // 提交-开通交易帐号单
  commitTradeAccount(params) {
    return axios.post('/trade/trade-account/application', params)
  }
  // 实时行情服务-申请列表-主页
  getQuoteService(params) {
    return axios.get('/trade/quote-service', { params: params })
  }
  // 提交-实时行情服务单
  commitQuoteService(params) {
    return axios.post('/trade/quote-service/application', params)
  }
  // 取消-实时行情服务单
  cancelQuoteService(params) {
    return axios.post('/trade/quote-service/application/cancel', params)
  }
  // 提交-结构性产品单
  // commitStructuredProduct (params) {
  //   return axios.post('/trade/structured-product/application', params)
  // }
  // 提交-结构性产品单-新版
  commitStructuredProduct(params) {
    return axios.post('/trade/structured-product/application/new', params)
  }
  // 结构性产品单-最近的记录
  getStructuredRecords(params) {
    return axios.get('/trade/structured-product/status', { params: params })
  }

  // 结构性产品单-开通状态
  getStructuredStatus(params) {
    return axios.get('/trade/structured-product/status', { params: params })
  }

  // 个人中心-帐号信息
  getAccountInfo(params) {
    return axios.get('/trade/query-account-info', { params: params })
  }
  // 帐户设置-证券（现金）-修改密码
  changeSecuritiesPwd(params) {
    return axios.post('/trade/securitiesCash/changePassword', params)
  }
  // 帐户设置-证券（保证金）-修改密码
  changeSecuritiesMarginPwd(params) {
    return axios.post('/trade/securitiesMargin/changePassword', params)
  }
  // 帐户设置-期货-修改密码
  changeFuturesMarginPwd(params) {
    return axios.post('/trade/futuresMargin/changePassword', params)
  }
  // 帐户设置-期货-修改密码
  changeFuturesDayTradingMarginPwd(params) {
    return axios.post('/trade/futuresDayTradingMargin/changePassword', params)
  }
  // 帐户设置-全权委托(证券)-修改密码
  changeSecuritiesAyersCashPwd(params) {
    return axios.post('/trade/securitiesAyersCash/changePassword', params)
  }
  // 业务申请-其他交易帐户-列表-新版
  getTradeAccountInfo(params) {
    return axios.get('/trade/other-trade-accounts-new', { params: params })
  }
  // 提交-停用或关闭交易账户
  submitStopAccount(params) {
    return axios.post('/trade/trade-account-stop/application', params)
  }
  // 帐户设置-外汇(MT5)-修改密码
  changeMt5Password(params) {
    return axios.post('/trade/mt5/changePassword', params)
  }
  resetMt5Password(params) {
    return axios.post('/trade/mt5/resetPassword', params)
  }

  getTotalBalance(params) {
    return axios.post('/trade/transaction/totalBalanceList', params)
  }
  // 获取账户资金总和
  getTotalAmount(params) {
    return axios.get(`/trade/transaction/totalBalance`, { params })
  }

  // 业务申请-其他交易帐户-列表-新版-提交前校验
  verifyAccount(params) {
    return axios.get(`/trade/other-trade-accounts-new/verify`, { params })
  }

  // 实时行情服务-提交前校验
  verifyQuote(params) {
    return axios.get(`/trade/quote-service/verify`, { params })
  }

  // 根据用户交易帐号查询各币种的余额
  getNewBalance(params) {
    return axios.get(`/fund/stock`, { params })
  }
  // 查询用户开户时投资经验信息
  getInvestmentInfo(params, ctx) {
    return axios.get(`/trade/user/investment/info`, { params, ctx: ctx })
  }
  // 申请开通交易账户前检查
  getPreCheckResult(params) {
    return axios.get(`/apply/account/pre-check`, { params })
  }

  /**
   * 获取衍生品测试问卷列表
   * @param {Object} params - 请求参数
   * @returns {Promise} - 返回axios的GET请求Promise
   */
  getQuestionList(params) {
    return axios.get(`/derivativeTestQuestion/derivativeTest/questionnaire`, {
      params
    })
  }
  /**
   * 提交衍生品测试问卷答案
   * @param {Object} params - 提交的问卷答案参数
   * @param {Object} ctx - 请求上下文
   * @returns {Promise} - 返回axios的POST请求Promise
   */
  submitQuestionList(params) {
    return axios.post(
      '/derivativeTestQuestion/derivativeTest/questionnaire/submit',
      params
    )
  }
  getDerivativeDayCount(params) {
    return axios.get(`/derivativeTestQuestion/getDerivativeDayCount`, {
      params
    })
  }

  /**
   * 设置衍生品基础信息
   * @param {Object} params - 需要提交的基础信息参数
   * @param {Object} ctx - 请求上下文
   * @returns {Promise} - 返回axios的POST请求Promise
   */
  setDerivativeBaseInfo(params) {
    return axios.post('/derivativeTestQuestion/setDerivativeBaseInfo', params)
  }
}

export default new Trade()
